<template>
  <div id="main_page" class="xs-container">
    <div class="background-image">
      <img src="@/assets/img/main/background.png" alt="main-logo" />
    </div>

    <div class="main-content">
      <!-- Banner Section -->
      <BannerSection />

      <!-- Jackpot Section -->
      <div class="section-title flex items-center">
        <div class="box"></div>
        <div class="text">HOT JACKPOTS</div>
      </div>
      <JackpotSection />

      <!-- Game Theme Section -->
      <div class="w-full flex justify-between items-end">
        <div class="section-title flex items-center">
          <div class="box blue"></div>
          <div class="text">FEATURED GAMES</div>
        </div>
        <div class="game-etc flex justify-end items-center">
          <v-btn
            v-if="getLoginCheck"
            class="favorite-filter mr-1"
            elevation="0"
            :class="getIsFilteredFavorite ? 'active' : ''"
            @click="toggleFavorite"
          >
            <div class="flex justify-center items-center">
              <img
                v-if="getIsFilteredFavorite"
                src="@/assets/img/allgame/heart-active.png"
                class="w-6 h-6"
              />
              <img
                v-else
                src="@/assets/img/allgame/heart-inactive.png"
                class="w-6 h-6"
              />
              <div class="flex-1 text-center">
                {{ $t("allGames.favorites") }}
              </div>
            </div>
          </v-btn>

          <v-btn class="quick-join" elevation="0" @click="getRandomGame">
            <div class="flex justify-center items-center">
              <img src="@assets/img/game-list/quick-play.png" class="w-6 h-6" />
              <div class="flex-1 text-center">Quick Join</div>
            </div>
          </v-btn>
        </div>
      </div>
      <GameThemeSection />

      <!-- Game List Section -->
      <GameGroupForm />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import BannerSection from "@views/components/main/BannerSection.vue";
import JackpotSection from "@views/components/main/JackpotSection.vue";
import GameThemeSection from "@views/components/main/GameThemeSection.vue";
import GameGroupForm from "@views/components/common/GameGroupForm.vue";
import { MACHINE_STATE } from "@/utils/machineState";
import EventBus from "@/utils/EventBus";
import globalMixin from "@/mixins/globalMixin";
import { AuthNamespace } from "@/store/auth";

export default {
  name: "MainPage",
  mixins: [globalMixin],
  components: {
    BannerSection,
    JackpotSection,
    GameThemeSection,
    GameGroupForm,
  },
  data() {
    return {};
  },
  mounted() {
    if (this.getLoginCheck) {
      const existDirectGameId = this.$cookies.get("direct_game");
      const existDirectPlayViewId = this.$cookies.get("direct_playView");
      if (existDirectGameId) {
        this.$cookies.remove("direct_game");
        // ?좏깮??癒몄떊???ъ슜???뺣낫 ?깅줉
        if (this.$device.mobile) {
          EventBus.$emit("directionSelect/machine_id", existDirectGameId);
          this.setDialog("directionSelect", true);
        } else {
          this.createMachinePlayer(existDirectGameId);
        }
      }
      if (existDirectPlayViewId) {
        this.$cookies.remove("direct_playView");
        const targetMachine = this.getMachineList.find(
          (item) => item.id === existDirectPlayViewId
        );
        if (targetMachine) {
          this.setPlayViewMachine(targetMachine);
          this.ACTION_READ_MACHINE_GAME_TYPE(targetMachine.id);
          this.setDialog("playView", true);
        }
      }
    }
  },
  computed: {
    ...mapGetters(AuthNamespace, ["getLoginCheck"])
  },
  methods: {
    getRandomGame() {
      const availableGameList = this.getMachineList.filter(
        (item) => item.status === MACHINE_STATE.IDLE
      );
      if (availableGameList.length !== 0) {
        const randomMachine =
          availableGameList[Math.randomRange(0, availableGameList.length - 1)];

        if (!this.getLoginCheck) {
          this.$cookies.set("direct_game", randomMachine.id, 60 * 10);
          this.setDialog("signIn", true);
          return;
        }

        if (this.$device.mobile) {
          EventBus.$emit("directionSelect/machine_id", randomMachine.id);
          this.setDialog("directionSelect", true);
        } else {
          this.createMachinePlayer(randomMachine.id);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/import.scss";

.background-image {
  position: absolute;
  top: 0%;
  left: 0%;
  z-index: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  img {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);

    @include device-desktop() {
      width: 2560px;
      max-width: 2560px;
    }

    @include device-lte-tablet() {
      width: 100%;
      max-width: 100%;
      min-width: 960px;
    }
  }
}
.main-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .section-title {
    color: #fff;
    font-family: Inter;
    font-size: 2rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -1.4px;
    margin-top: 1.5rem;

    @include device-mobile() {
      font-size: 1.5rem;
    }
    .box {
      width: 5px;
      height: 22px;
      background-color: #ffd57c;
      border-radius: 1px;
      margin-right: 11px;
      &.blue {
        background-color: #04e7f8;
      }
    }
  }

  .v-btn {
    width: 7.5rem;
    height: 2.5rem;
    padding: 0.5rem 0.4rem;
    border-radius: 5px;
    color: #fff;
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: -0.0525rem;

    @include device-lte-tablet() {
      width: 6rem;
      height: 2rem;
      font-size: 0.7rem;
    }

    &.favorite-filter {
      border: 1px solid rgba(181, 187, 203, 0.2);
      background: #292b3d;
      backdrop-filter: blur(5px);
      color: #535b86;
      transition: all 0.2s;
      &.active {
        background-color: #8990d3;
        color: #fff;
      }
      &:disabled {
        border: 1px solid rgba(181, 187, 203, 0.2);
        background: #292b3d;
        backdrop-filter: blur(5px);
        color: #535b86;
      }
      &:hover {
        filter: brightness(1.1);
      }
    }

    &.quick-join {
      background: linear-gradient(0deg, #a16100 0%, #d68000 100%);
      backdrop-filter: blur(5px);
      .v-btn__content {
        .v-icon {
          width: 1.5rem;
          height: 1.5rem;
          background: url(@assets/img/game-list/quick-play.png) no-repeat;
          background-size: 100% 100%;
          margin-right: 0.3rem;
        }
      }
      &:hover {
        filter: brightness(1.1);
      }
    }
  }
}
</style>

